import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { CejV2RecontactInfo } from '@models/cej/cej-recontact-info';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CejService {
  constructor(private readonly http: HttpClient) {}

  registerForFutureContact(userInfo: CejV2RecontactInfo): Observable<CejV2RecontactInfo> {
    const endpoint = `${environment.api.event}/v1/cej/contact`;
    return this.http.post<CejV2RecontactInfo>(endpoint, userInfo);
  }
}
